// eslint-disable-next-line import/prefer-default-export
export const excludeTemplates = ["ppc", "responsible_gambling_guide"];

export const excludeStatusInactiveToplist = {
  "playcasino.co.za": ["active", "coming_soon"],
  default: ["active"],
};
